import { createAsyncThunk } from '@reduxjs/toolkit';
import { StashCategory } from '@stash/shared-types';
import { getTopLevelCategories } from '../services/category-service';
import log from '@/services/log';

interface CategoriesState {
  categories: StashCategory[];
  isLoading: boolean;
  error: string | null;
}

interface ThunkState {
  categories: CategoriesState;
}

export const fetchCategoriesAsync = createAsyncThunk<
  StashCategory[],
  void,
  { state: ThunkState; rejectValue: string }
>(
  'categories/fetchTopLevel',
  async (_, { getState, rejectWithValue }) => {
    const { categories } = getState().categories;
    if (categories.length > 0) {
      return categories;
    }

    try {
      const apiCategories = await getTopLevelCategories();
      return apiCategories;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to fetch categories';
      log.error('Failed to fetch categories:', error);
      return rejectWithValue(message);
    }
  }
);
